import { FC } from 'react'
import { CompanySettingsTargetsTemplatesInfoBox } from './CompanySettingsTargetsTemplatesInfoBox'
import { CompanySettingsTargetsTemplatesTable } from './CompanySettingsTargetTemplatesTable'
import { useCompanySettingsStore } from '../CompanySettingsStore'
import { useCompanySettingsTargetsTemplates } from '../../../graphql/companySettings/useCompanySettingsTargetsTemplates'
import shallow from 'zustand/shallow'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { TargetTemplateModal } from '../../../components/custom_components/TargetTemplateModal/TargetTemplateModal'
import { useAuth } from '../../../context/auth-context'
import { RoleName } from '../../../types'
import { useUserManagersRolesByCompany } from '../../../graphql/company/hooks/useUserManagerRolesByCompany'

export const CompanySettingsTargetsTemplatesTab: FC = () => {
  const [selected] = useCompanySettingsStore((state) => [state.selected], shallow)
  const { data, error, loading } = useCompanySettingsTargetsTemplates(selected.companyId, selected.country)
  const { user } = useAuth()

  const { data: userRolesData } = useUserManagersRolesByCompany(selected.companyId)
  const userRoles: RoleName[] =
    userRolesData && userRolesData.findUserManagerRolesByCompany ? userRolesData.findUserManagerRolesByCompany : []
  const isHrForSelectedCountry = user.roles
    ? user.roles
        .filter((employeeRole) => employeeRole.includes('HR_'))
        .filter((employeeRole) => {
          const roleParts = employeeRole.split('_')
          return roleParts[2] === selected.country
        }).length > 0
    : false
  const permissionToChangeTarget: boolean = user.roles
    ? isHrForSelectedCountry || userRoles.includes(RoleName.CompanyManager) || userRoles.includes(RoleName.BusinessPartner)
    : false

  if (loading || error || !data || !data.targetTemplatesOfCompany) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} showSpinner />
  } else {
    return (
      <>
        <CompanySettingsTargetsTemplatesInfoBox
          resultLength={data.targetTemplatesOfCompany.length}
          permissionToChangeTarget={permissionToChangeTarget}
        />
        <CompanySettingsTargetsTemplatesTable
          tableData={data.targetTemplatesOfCompany}
          permissionToChangeTarget={permissionToChangeTarget}
        />
        <TargetTemplateModal />
      </>
    )
  }
}
